export default {
  title: "Portal",
  button: "Fortsett med Facebook"
}



// WEBPACK FOOTER //
// ./src/locales/no/page/portal.js